import React, { useEffect, useState } from "react";
import {
  collection,
  addDoc,
  deleteDoc,
  updateDoc,
  onSnapshot,
  doc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

import "./ChavesAtivacao.css";

export default function ChavesAtivacao() {
  const [planos, setPlanos] = useState([]);
  const [chaves, setChaves] = useState([]);
  const [planoId, setPlanoId] = useState("");

  useEffect(() => {
    onSnapshot(collection(db, "planos"), (snap) => {
      setPlanos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });

    onSnapshot(collection(db, "chavesAtivacao"), (snap) => {
      setChaves(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
  }, []);

  const gerarCodigo = () =>
    Math.random().toString(36).substring(2, 10).toUpperCase();

  const criarChave = async () => {
    if (!planoId) return alert("Selecione um plano!");

    await addDoc(collection(db, "chavesAtivacao"), {
      codigo: gerarCodigo(),
      planoId,
      usado: false,
      criadoEm: Timestamp.now(),
    });

    alert("Chave criada!");
  };

  const marcarUsado = async (id) => {
    await updateDoc(doc(db, "chavesAtivacao", id), { usado: true });
  };

  const removerChave = async (id) => {
    await deleteDoc(doc(db, "chavesAtivacao", id));
  };

  return (
    <div className="app-container">
      <Sidebar />
      <div className="main-content">
        <Topbar />

        <div className="chaves-container">
          <h2>Chaves de Ativação</h2>

          <div className="form-card">
            <label>Plano</label>
            <select
              value={planoId}
              onChange={(e) => setPlanoId(e.target.value)}
            >
              <option value="">Selecione...</option>
              {planos.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.nome} – R${p.preco}
                </option>
              ))}
            </select>

            <button className="btn-criar" onClick={criarChave}>
              Criar chave
            </button>
          </div>

          <table className="chaves-table">
            <thead>
              <tr>
                <th>Código</th>
                <th>Plano</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {chaves.map((c) => (
                <tr key={c.id}>
                  <td>{c.codigo}</td>
                  <td>{planos.find((p) => p.id === c.planoId)?.nome}</td>
                  <td>{c.usado ? "Usado" : "Disponível"}</td>
                  <td>
                    {!c.usado && (
                      <button
                        className="btn-usado"
                        onClick={() => marcarUsado(c.id)}
                      >
                        Marcar usado
                      </button>
                    )}

                    <button
                      className="btn-del"
                      onClick={() => removerChave(c.id)}
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
